module.exports = __webpack_public_path__ + "img/c46856f.jpg";